import { j as l } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as t } from "react";
import { I as r } from "../../../../IconBase-CxZyIWw2.js";
const i = t((a, o) => /* @__PURE__ */ l.jsx(
  r,
  {
    ref: o,
    ...a,
    image: (e) => /* @__PURE__ */ l.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        fill: "none",
        viewBox: "0 0 32 32",
        ...e,
        children: /* @__PURE__ */ l.jsx(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M6.764 9.682a3 3 0 0 1-1.763 4.255L.477 15.351a.68.68 0 0 0 0 1.299l4.524 1.413a3 3 0 0 1 1.763 4.256l-2.2 4.199a.68.68 0 0 0 .919.918l4.199-2.2a3 3 0 0 1 4.255 1.762l1.414 4.525a.68.68 0 0 0 1.299 0l1.413-4.524a3 3 0 0 1 4.256-1.763l4.198 2.2a.68.68 0 0 0 .918-.918l-2.2-4.2A3 3 0 0 1 27 18.064l4.524-1.413a.68.68 0 0 0 0-1.299l-4.524-1.414a3 3 0 0 1-1.763-4.255l2.2-4.199a.68.68 0 0 0-.919-.918l-4.198 2.2A3 3 0 0 1 18.063 5L16.65.477a.68.68 0 0 0-1.299 0l-1.414 4.525a3 3 0 0 1-4.255 1.763l-4.2-2.2a.68.68 0 0 0-.917.918zM23 16a7 7 0 1 1-14 0 7 7 0 0 1 14 0m-7 5a5 5 0 1 0 0-10 5 5 0 0 0 0 10",
            clipRule: "evenodd"
          }
        )
      }
    )
  }
));
i.displayName = "SunProtectionIcon";
export {
  i as SunProtectionIcon,
  i as default
};
//# sourceMappingURL=index.js.map
